import axios from "axios";
import swal from "sweetalert2";

import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { globalState, accessTokenKey, baseUrl } from "../utils/config";

function Verify() {
    const navigate = useNavigate();
    const [submitting, setSubmitting] = useState(false);
    const [state, setState] = useState(globalState.state);

    async function login() {
        setSubmitting(true);

        try {
            const form = document.getElementById("form-login");
            const formData = new FormData(form);
            formData.append("email", localStorage.getItem("email") || "");

            const response = await axios.post(
                baseUrl + "/api/verify",
                formData,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                    }
                }
            );

            if (response.data.status == "success") {
                const accessToken = response.data.access_token;
                /*const user = response.data.user;
                globalState.setState({
                    user: user
                });*/
                localStorage.setItem(accessTokenKey, accessToken);
                localStorage.removeItem("email");

                fetchMe();
            } else {
                swal.fire("Error", response.data.message, "error");
            }
        } catch (exp) {
            console.log(exp.message);
        } finally {
            setSubmitting(false);
        }

        async function fetchMe() {
            try {
                const response = await axios.post(
                    baseUrl + "/api/me",
                    null,
                    {
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem(accessTokenKey)
                        }
                    }
                );

                if (response.data.status == "success") {
                    const user = response.data.user;
                    setState({
                        user: user
                    });
                    globalState.setState({
                        user: user
                    });
                    navigate("/");
                } else {
                    // swal.fire("Error", response.data.message, "error")
                }
            } catch (exp) {
                console.log(exp.message);
            }
        }
    }

    return (
        <>
            <div className="container-xxl py-5 bg-dark page-header mb-5">
                <div className="container my-5 pt-5 pb-4">
                    <h1 className="display-3 text-white mb-3 animated slideInDown">Verify</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb text-uppercase">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item text-white active" aria-current="page">Verify</li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div className="container-xxl py-5">
                <div className="container">
                    <h1 className="text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">Verify</h1>
                    <div className="row g-4">
                        <div className="col-md-12">
                            <div className="wow fadeInUp" data-wow-delay="0.5s">
                                <p className="mb-5 text-center">Enter code sent on your email address to login.</p>

                                <form onSubmit={ function (event) {
                                    event.preventDefault();
                                    login();
                                } } id="form-login">
                                    <div className="row g-3">
                                        <div className="offset-md-3 col-md-6">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-floating">
                                                        <input type="text" className="form-control" name="code" placeholder="Code" required />
                                                        <label>Code</label>
                                                    </div>
                                                </div>

                                                <div className="col-md-12 mt-3">
                                                    <button className="btn btn-primary w-100" type="submit"
                                                        disabled={ submitting }>Login</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Verify;